import React, { Fragment, useState, useContext } from 'react';
import { User } from 'react-feather';
import { Link } from 'react-router-dom';
import { LI } from '../../../AbstractElements';
import ConfigDB from '../../../Config/ThemeConfig';
import CustomizerContext from '../../../_helper/Customizer';

const Profile = () => {
    const { addMixBackgroundLayout } = useContext(CustomizerContext);
    const [moonlight, setMoonlight] = useState(false);
    const localStorageLayout = localStorage.getItem('layout_type') || ConfigDB.data.settings.layout_type;

    const MoonlightToggle = (light) => {
        if (light) {
            addMixBackgroundLayout('light-only');
            document.body.classList.add("light-only");
            document.body.classList.remove("dark-only");
            document.body.classList.remove("dark-sidebar");
            document.body.classList.add(localStorageLayout);
            setMoonlight(!light);
        } else {
            addMixBackgroundLayout('dark-only');
            document.body.classList.add("dark-only");
            document.body.classList.remove("dark-sidebar");
            document.body.classList.remove("light-only");
            document.body.classList.add(localStorageLayout);
            setMoonlight(!light);
        }
    };
    return (
        <Fragment>
            <LI>
            <Link style={{textDecoration: 'none',color:'#212529'}} to={`/app/users/userEdit`}>
                <div className="mode" >
                <User/>
                </div>
            </Link>
            </LI>
        </Fragment>
    );
};

export default Profile;